// extracted by mini-css-extract-plugin
export default {"searchInput":"SearchInput_searchInput__n74oL","searchButton":"SearchInput_searchButton__fO5Sa"};